import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-first-logon',
  templateUrl: './first-logon.component.html',
  styleUrls: ['./first-logon.component.css']
})
export class FirstLogonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
